const shared = {
  common: {
    yes: 'Oui',
    no: 'Non',
    update: 'Sauvegarder',
    edit: 'Modifier',
    language: 'Fr',
    errorMsg: 'Erreur ',
    loadingMsg: 'telechargement',
    canada: {
      provinces: {
        'All Provinces': 'Toutes les provinces',
        Alberta: 'Alberta',
        'British Columbia': 'Colombie-Britannique',
        Manitoba: 'Manitoba',
        'New Brunswick': 'Nouveau-Brunswick',
        'Newfoundland and Labrador': 'Terre-Neuve-et-Labrador',
        'Northwest Territories': 'Territoires du Nord-Ouest',
        'Nova Scotia': 'Nouvelle-Écosse',
        Nunavut: 'Nunavut',
        Ontario: 'Ontario',
        'Prince Edward Island': 'L\'île du Prince-Édouard',
        Quebec: 'Quebec',
        Saskatchewan: 'Saskatchewan',
        Yukon: 'Yukon',
        International: 'International'
      }
    },
    gender: {
      m: 'Male',
      f: 'Female'
    },
    preferedLanguage: {
      ENGLISH: 'Anglais',
      FRENCH: 'Français'
    }
  }
}

export default shared
